import React from "react";
import { SendFiles } from "./sendFiles";

const cardOption = {
    background: "#FFFFFF",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.15)",
    borderRadius: "1.5rem",
};

export const UploadArea = ({ browseFiles, children }) => {
    return (
        <div className="card" style={cardOption}>
            <SendFiles browseFiles={browseFiles} />
            {children}
        </div>
    );
};
